import { SIDEBAR_COLLAPSED_ATTR, SIDEBAR_COLLAPSED_KEY } from "@hulahoop/ui";
import { getLocalStorageService } from "@/infrastructure/di/services";

/** Restores the sidebar preference before the first paint, like the design system docs layout. */
export function initSidebarPreference() {
  if (getLocalStorageService().get<string>(SIDEBAR_COLLAPSED_KEY) === "collapsed") {
    document.documentElement.setAttribute(SIDEBAR_COLLAPSED_ATTR, "");
  }
}
